import styled from "@emotion/styled";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { useMediaQuery, translate } from "@kaltura/mediaspace-shared-utils";
import { Button, Modal, ModalTitle, ModalContent, ModalActions } from "@kaltura/ds-react-components";
import VerticalFilterBar, { VerticalFilterBarProps } from "../vertical-filter-bar/VerticalFilterBar";
import { useContext } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

export interface FilterBarProps extends VerticalFilterBarProps {
    isModalOpen?: boolean;
    onModalClose?: () => void;
    inModal?: boolean;
}

const StyledModalContent = styled(ModalContent)({
    minWidth: 391,
});

const baseClassName = "kms-ds-filters-modal";

/**
 * global search filter bar
 */
export function FilterBar(props: FilterBarProps) {
    const { isModalOpen = false, onModalClose, inModal, ...filterbarProps } = props;

    const theme = useTheme();
    const mdScreen = useMediaQuery(theme.breakpoints.up("md"));

    // check from context if this is kaf
    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    const sendButtonAnalytics = useButtonAnalytics();

    const handleClose = () => {
        sendButtonAnalytics("Close filters", ButtonClickAnalyticsType.TOGGLE, undefined, undefined, "Modal - Filters");

        onModalClose?.();
    };

    return (
        <ButtonAnalyticsProvider location={"Modal - Filters"} applicationFeature={"Search"}>
            {mdScreen && !inModal && !isKaf && <VerticalFilterBar {...filterbarProps} />}
            {(!mdScreen || isKaf || inModal) && (
                <Modal
                    open={isModalOpen}
                    onClose={handleClose}
                    classes={{ paper: baseClassName }}
                    className={`${baseClassName}-outer`}
                >
                    <ModalTitle className={`${baseClassName}-title`}>{translate("Filters")}</ModalTitle>
                    <StyledModalContent className={`${baseClassName}-content`}>
                        <VerticalFilterBar {...filterbarProps} />
                    </StyledModalContent>
                    <ModalActions className={`${baseClassName}-actions`}>
                        <Button
                            variant="borderless"
                            color={"secondary"}
                            onClick={handleClose}
                            className={`${baseClassName}-actions-close-button`}
                        >
                            {translate("Close")}
                        </Button>
                    </ModalActions>
                </Modal>
            )}
        </ButtonAnalyticsProvider>
    );
}
export default FilterBar;
